import theme from 'src/styles/theme'
import styled from 'styled-components'
import { Button, Checkbox } from '@mui/material'
import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 1280px;
    gap: 1.2rem;
`

export const ConfirmCheckbox = styled(Checkbox)`
    color: ${theme.colors.gray3} !important;

    &.Mui-checked {
        color: ${theme.colors.green2} !important;
    }
`

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
`

export const ConfirmButton = styled(Button)`
    background: ${theme.colors.green2} !important;

    &:disabled {
        background: ${theme.colors.gray} !important;
    }
`

export const RePrintButton = styled(Button)`
    background: ${theme.colors.red} !important;
`

export const InvoiceListContainer = styled.div`
    width: 100%;
    border: 1px solid ${theme.colors.gray3};
    border-radius: 8px;
    padding: 1rem;
`

export const InvoiceListTitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
`

export const InvoiceListTitle = styled.span`
    font-size: 18px;
`

export const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
`

export const ListItem = styled.li`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px;
    border-bottom: 1px solid ${theme.colors.gray3};
    &:last-child {
        border-bottom: none;
    }
`

export const ListItemContainer = styled.div`
    display: grid;
    grid-template-columns: 33% 40% 20% 7%;
    width: 100%;
`

export const ListItemText = styled.span<{ textColor?: string }>`
    flex: 1;
    font-size: 16px;
    color: ${({ textColor }) => textColor || 'inherit'};
`

export const OkButton = styled(ButtonMui)`
    width: 40px;
    height: 25px;
`

export const CustomTextField = styled(TextFieldMui)`
    margin: 0;
`
